import { Task } from 'shared/types/task';
import { TaskPriorityOptions } from 'shared/types/task-base';

// undefined means the selection disagrees — distinct from agreeing on None.
export const getSharedPriorityValue = (
  tasks: Task[],
): TaskPriorityOptions | undefined => {
  if (!tasks.length) {
    return undefined;
  }

  const firstValue = tasks[0].priority ?? TaskPriorityOptions.None;
  const isShared = tasks.every(
    ({ priority }) => (priority ?? TaskPriorityOptions.None) === firstValue,
  );

  return isShared ? firstValue : undefined;
};
